import React from "react";
import './style.css'
import Button from "../CtaButton";

const SubscriptionCard = ({ plan }) => {
    return (
        <div className="col-xl-4 col-lg-4 col-md-6 mt-5">
            <div className="subscription-card-main-box">
                <div className="subscription-card-text-box">
                    <h5 className="subscription-card-main-heading">{plan.package} <h6 className="d-inline-block">/ {plan.hoursIncluded}</h6></h5>

                    <div className="text-center mb-3">
                        {/* <p className="subscripton-card-price-before mb-1">
                            <del>{plan.priceBefore}</del>
                        </p> */}
                        <h4 className="subscription-card-price-text">{plan.priceNow}</h4>
                        {/* <h5 className="price-tag-subscription-card">{plan.hoursIncluded}</h5> */}
                    </div>

                    {/* <ul className="list-unstyled subscription-card-list-text mb-3">
                        <li className="subscription-card-sub-headings"><strong>Hours Included:</strong> {plan.hoursIncluded}</li>
                        <ul className="subscription-card-list ps-3">
                            <li>{plan?.rolesIncluded}</li>
                        </ul>
                    </ul> */}

                    <div className="mb-3">
                        <strong className="subscription-card-sub-headings">Package Features:</strong>
                        <ul className="subscription-card-list ps-3">
                            {plan.features.map((feature, i) => (
                                <li key={i}>{feature}</li>
                            ))}
                        </ul>
                    </div>

                    <p className="mt-auto text-white"><strong className="subscription-card-sub-headings">Perfect For:</strong> {plan.perfectFor}</p>
                </div>

                <div className="text-center mt-3">
                    <Button text="Subscribe Now" newTab link={plan?.subscribeLink} className="w-100" />
                    {/* {plan?.upgradable === true ? <Button appearance="outline" text="Upgrade Plan" className="w-100 mt-3" link={plan?.upgradeLink} /> : ""} */}
                </div>
            </div>
        </div>
    );
};

export default SubscriptionCard;